/* Salty Editorial — storefront interactions (vanilla, no deps) */
(() => {
  const S = window.Salty || { routes: {}, i18n: {}, lowStock: 3 };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = cents => `${(cents / 100).toFixed(2).replace(/\.00$/, '')} ₪`;
  const t = (k, n) => (S.i18n[k] || '').replace('__N__', n);

  /* ---------- toast ---------- */
  const toast = msg => {
    const el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('is-on');
    clearTimeout(toast.t); toast.t = setTimeout(() => el.classList.remove('is-on'), 2800);
  };

  /* ---------- overlays ---------- */
  let openEl = null, lastFocus = null;
  const scrim = () => $('[data-scrim]');
  const focusables = el => $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', el).filter(x => x.offsetParent !== null);
  const setExpanded = (el, v) => el && el.id && $$(`[data-open="#${el.id}"]`).forEach(b => b.setAttribute('aria-expanded', v));
  function open(el) {
    if (!el) return;
    close(false); openEl = el; lastFocus = document.activeElement;
    el.classList.add('is-on'); scrim() && scrim().classList.add('is-on');
    el.setAttribute('aria-hidden', 'false'); setExpanded(el, 'true');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => { const f = el.querySelector('input[type="search"]') || focusables(el)[0]; f && f.focus(); }, 320);
  }
  function close(restore = true) {
    if (!openEl) return;
    const el = openEl;
    el.classList.remove('is-on'); scrim() && scrim().classList.remove('is-on');
    el.setAttribute('aria-hidden', 'true'); setExpanded(el, 'false');
    document.documentElement.style.overflow = ''; openEl = null;
    el.dispatchEvent(new CustomEvent('overlay:close'));
    if (restore && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') return close();
    if (e.key !== 'Tab' || !openEl) return;
    const f = focusables(openEl); if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- cart ---------- */
  const drawer = () => $('#CartDrawer');
  function renderDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#CartDrawer'), cur = drawer();
    if (!fresh || !cur) return;
    cur.innerHTML = fresh.innerHTML;
    cur.dataset.count = fresh.dataset.count;
    const n = +fresh.dataset.count || 0;
    $$('[data-cart-count]').forEach(el => { el.textContent = n; el.classList.toggle('is-on', n > 0); });
    init(cur);
  }
  async function cartPost(url, body) {
    const d = drawer(); d && d.classList.add('is-busy');
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: 'cart-drawer', sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'שגיאה');
      renderDrawer(data.sections && data.sections['cart-drawer']);
      return data;
    } finally { d && d.classList.remove('is-busy'); }
  }
  async function add(id, qty = 1, btn) {
    btn && btn.classList.add('is-busy');
    try {
      await cartPost(`${S.routes.cartAdd}.js`, { items: [{ id: +id, quantity: qty }] });
      open(drawer());
    } catch (err) { toast(err.message); }
    finally { btn && btn.classList.remove('is-busy'); }
  }
  async function change(line, quantity) {
    try { await cartPost(`${S.routes.cartChange}.js`, { line: +line, quantity: +quantity }); }
    catch (err) { toast(err.message); }
  }

  /* ---------- product data helpers ---------- */
  const readJSON = scope => {
    const el = scope && scope.querySelector('[data-product-json]');
    try { return el ? JSON.parse(el.textContent) : null; } catch (_) { return null; }
  };
  const stockMsg = q => q >= 999 ? S.i18n.inStock : q === 1 ? S.i18n.lastOne : q <= S.lowStock ? t('fewLeft', q) : S.i18n.inStock;
  // for single-option products: value -> { variant, qty }
  const byValue = p => p.variants.map(v => ({ v, value: v.options[0], qty: v.available ? v.qty : 0 }));
  function chip(value, qty, onPick) {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'size'; b.textContent = value; b.setAttribute('aria-pressed', 'false');
    if (qty <= 0) { b.classList.add('is-out'); b.disabled = true; b.setAttribute('aria-label', `${value} · ${S.i18n.soldOut}`); }
    else if (qty <= S.lowStock) b.classList.add('is-low');
    b.addEventListener('click', () => onPick(b));
    return b;
  }

  /* ---------- quick add (sheet + hover chips) ---------- */
  const sheet = () => $('#QuickSheet');
  let sheetPick = null;
  function quick(p) {
    const sh = sheet(); if (!sh || !p) return;
    if (p.options.length > 1) { location.href = p.url; return; }
    $('[data-s-t]', sh).textContent = p.title;
    const first = p.variants[0];
    $('[data-s-v]', sh).innerHTML = `<span class="ltr">${money(first.price)}</span>`;
    $('[data-s-link]', sh).href = p.url;
    const img = $('[data-s-img]', sh);
    img.innerHTML = p.image ? `<img class="ph__media" src="${p.image}" alt="">` : '';
    img.classList.toggle('ph--img', !!p.image);
    const box = $('[data-s-sizes]', sh), msg = $('[data-s-msg]', sh), btn = $('[data-s-add]', sh);
    box.innerHTML = ''; msg.textContent = ''; msg.className = 'size-msg';
    btn.disabled = true; btn.textContent = S.i18n.choose; sheetPick = null;
    byValue(p).forEach(({ v, value, qty }) => box.appendChild(chip(value, qty, b => {
      $$('.size', box).forEach(x => { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); }); b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
      sheetPick = v.id;
      msg.textContent = stockMsg(qty); msg.classList.toggle('is-low', qty <= S.lowStock);
      btn.disabled = false; btn.textContent = `${S.i18n.add} · ${money(v.price)}`;
    })));
    open(sh);
  }
  document.addEventListener('click', e => {
    const sAdd = e.target.closest('[data-s-add]');
    if (sAdd && sheetPick) { add(sheetPick, 1, sAdd); return; }
  });

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); open($(o.dataset.open)); return; }
    if (e.target.closest('[data-close]') || e.target.matches('[data-scrim]')) { close(); return; }
    const c = e.target.closest('[data-open-cart]');
    if (c) { e.preventDefault(); open(drawer()); return; }
    const qi = e.target.closest('[data-quick-id]');
    if (qi) { e.preventDefault(); add(qi.dataset.quickId, 1, qi); return; }
    const q = e.target.closest('[data-quick]');
    if (q) { e.preventDefault(); quick(readJSON(q.closest('.card, .look__item, .cart-upsell__row') || q.parentElement)); return; }
    const ln = e.target.closest('[data-line]');
    if (ln) { change(ln.dataset.line, ln.dataset.qty); return; }
    const tab = e.target.closest('.tab[data-filter]');
    if (tab) {
      const bar = tab.parentElement; $$('.tab', bar).forEach(x => x.classList.toggle('is-on', x === tab));
      const sec = tab.closest('.shopify-section') || document;
      const f = tab.dataset.filter;
      $$('[data-filter-grid] > [data-type]', sec).forEach(card => { card.style.display = f === 'all' || card.dataset.type === f ? '' : 'none'; });
      return;
    }
    const acc = e.target.closest('[data-open-acc]');
    if (acc) { const d = document.getElementById(acc.dataset.openAcc); if (d) { e.preventDefault(); d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }
  });

  /* ---------- per-root init (also after AJAX renders) ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(en => {
    if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
  }), { rootMargin: '0px 0px -8% 0px' }) : null;

  function init(root = document) {
    $$('.rv:not(.is-in)', root).forEach(el => io ? io.observe(el) : el.classList.add('is-in'));
    // hover quick-add chips on product cards (desktop)
    $$('[data-card-quick]:not([data-ready])', root).forEach(box => {
      box.dataset.ready = '1';
      const p = readJSON(box.closest('.card'));
      if (!p || p.options.length > 1) { box.remove(); return; }
      byValue(p).forEach(({ v, value, qty }) => box.appendChild(chip(value, qty, b => add(v.id, 1, b))));
    });
  }

  /* ---------- announcement ---------- */
  const reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function announce() {
    const bar = $('[data-announce]'), items = $$('.announce__item'); if (!bar || items.length < 2 || reduced) return;
    let i = 0, hold = false;
    ['mouseenter', 'focusin'].forEach(ev => bar.addEventListener(ev, () => hold = true));
    ['mouseleave', 'focusout'].forEach(ev => bar.addEventListener(ev, () => hold = false));
    setInterval(() => {
      if (hold || document.hidden) return;
      const prev = items[i]; prev.classList.remove('is-on'); prev.classList.add('is-out');
      setTimeout(() => prev.classList.remove('is-out'), 700);
      i = (i + 1) % items.length; items[i].classList.add('is-on');
    }, 4200);
  }

  /* ---------- header over cover ---------- */
  function headerOver() {
    const h = $('[data-header][data-over]'), cover = $('.cover');
    if (!h || !cover) { h && h.classList.remove('is-over'); return; }
    const f = () => h.classList.toggle('is-over', cover.getBoundingClientRect().bottom > h.offsetHeight + 1);
    f(); addEventListener('scroll', f, { passive: true });
  }

  /* ---------- pause controls for video / marquee / film (WCAG 2.2.2) ---------- */
  function motion() {
    $$('[data-motion-toggle]:not([data-ready])').forEach(btn => {
      btn.dataset.ready = '1';
      const scope = btn.closest('.cover, .vbreak, .band, .film') || btn.parentElement;
      const vids = $$('video', scope);
      const label = btn.getAttribute('aria-label');
      btn.addEventListener('click', () => {
        const paused = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? label.replace('עצירת', 'הפעלת') : label);
        scope.classList.toggle('is-paused', paused);
        vids.forEach(v => { paused ? v.pause() : playIfSeen(v); });
      });
    });
  }

  /* ---------- videos: play on their own once most of the frame is on screen ---------- */
  const seen = new WeakMap();
  const userPaused = v => !!v.closest('.is-paused');
  const playIfSeen = v => { if ((seen.get(v) || 0) >= .5 && !userPaused(v)) { v.muted = true; const p = v.play(); p && p.catch(() => {}); } };
  const vio = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(en => {
    seen.set(en.target, en.intersectionRatio);
    en.intersectionRatio >= .5 ? playIfSeen(en.target) : en.intersectionRatio < .15 && en.target.pause();
  }), { threshold: [0, .15, .5, .75] }) : null;
  function videos() {
    $$('video:not([data-auto])').forEach(v => {
      v.dataset.auto = '1'; v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      vio ? vio.observe(v) : v.play().catch(() => {});
    });
  }
  // iOS Low Power Mode blocks autoplay until the first touch, so retry then
  const kick = () => $$('video[data-auto]').forEach(playIfSeen);
  ['touchend', 'pointerdown', 'keydown'].forEach(ev => document.addEventListener(ev, kick, { passive: true, once: true }));

  /* ---------- club popup: opens after N seconds, X minimizes to a bottom block ---------- */
  function clubPopup() {
    const root = $('[data-cpop]'); if (!root) return;
    const dlg = $('#ClubPopup', root), mini = $('[data-cpop-open]', root);
    const KEY = 'salty-club-popup';
    const get = () => { try { return localStorage.getItem(KEY); } catch (_) { return null; } };
    const set = v => { try { localStorage.setItem(KEY, v); } catch (_) {} };
    const showMini = on => { mini.hidden = !on; mini.setAttribute('aria-expanded', on ? 'false' : 'true'); };
    const openPop = () => { showMini(false); open(dlg); };
    dlg.addEventListener('overlay:close', () => { if (get() !== 'joined') { set('min'); showMini(true); } });
    mini.addEventListener('click', openPop);
    // header person icon = join the club (logged-out visitors)
    document.addEventListener('click', e => { const a = e.target.closest('[data-club-open]'); if (a) { e.preventDefault(); openPop(); } });
    // after a successful signup (page reloads with the form result), show the thank-you once and stop
    if ($('[data-cpop-joined]', root)) { set('joined'); openPop(); return; }
    if ($('[data-cpop-error]', root)) { openPop(); return; }
    if (get() === 'joined') return;
    if (get() === 'min') { showMini(true); return; }
    const delay = (+root.dataset.delay || 5) * 1000;
    const tryOpen = () => { if (openEl) return setTimeout(tryOpen, 3000); openPop(); };
    setTimeout(tryOpen, delay);
  }
  /* ---------- drop: live countdowns, and flip the phase when its time comes ---------- */
  function drop() {
    const b = document.body; if (!b.dataset.dropClub) return;
    const at = { club: b.dataset.dropClub * 1000, public: b.dataset.dropPublic * 1000 };
    const forced = /[?&]drop=(pre|club|live|out)\b/.test(location.search);
    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      const now = Date.now();
      $$('[data-count-to]').forEach(el => {
        let left = Math.max(0, Math.floor((at[el.dataset.countTo] - now) / 1000));
        const d = Math.floor(left / 86400); left -= d * 86400;
        const h = Math.floor(left / 3600); left -= h * 3600;
        const m = Math.floor(left / 60), sec = left - m * 60;
        [['d', d], ['h', h], ['m', m], ['s', sec]].forEach(([k, v]) => { const x = $(`[data-${k}]`, el); if (x) x.textContent = pad(v); });
      });
      if (forced) return;
      const ph = now < at.club ? 'pre' : now < at.public ? 'club' : (b.dataset.dropAvail === '0' ? 'out' : 'live');
      if (ph !== b.dataset.dropPhase) location.reload(); // the page renders the new phase fresh (prices, stock, buy button)
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- signup forms: fix email typos (gmial → gmail), require an Israeli mobile ---------- */
  const DOMAINS = ['gmail.com', 'walla.co.il', 'walla.com', 'hotmail.com', 'hotmail.co.il', 'yahoo.com', 'yahoo.co.il', 'outlook.com', 'outlook.co.il', 'icloud.com', 'live.com', 'me.com', 'msn.com', 'bezeqint.net', 'netvision.net.il', 'zahav.net.il', '012.net.il', 'smile.net.il', 'aol.com', 'gmx.com', 'mail.com', 'protonmail.com', 'proton.me'];
  const dist = (a, b) => { // optimal string alignment distance (counts a swap as one edit)
    const d = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
    for (let j = 1; j <= b.length; j++) d[0][j] = j;
    for (let i = 1; i <= a.length; i++) for (let j = 1; j <= b.length; j++) {
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
    return d[a.length][b.length];
  };
  function fixEmail(raw) {
    let v = raw.trim().replace(/\s+/g, '').replace(/,/g, '.').replace(/\.+$/, '');
    const at = v.lastIndexOf('@'); if (at < 1) return v;
    let user = v.slice(0, at), dom = v.slice(at + 1).toLowerCase().replace(/^@+/, '');
    dom = dom.replace(/\.(con|cpm|vom|xom|comm|cim|cm|om|c0m|ocm)$/, '.com').replace(/\.(co\.ill|coil|co\.i|co\.l)$/, '.co.il');
    if (DOMAINS.includes(dom)) return `${user}@${dom}`;
    const label = dom.split('.')[0];
    let best = null, bd = 9;
    DOMAINS.forEach(D => {
      const n = Math.min(dist(dom, D), dom.includes('.') ? 9 : dist(label, D.split('.')[0]));
      if (n < bd) { bd = n; best = D; }
    });
    const limit = best && best.length >= 9 ? 2 : 1;
    return best && bd <= limit ? `${user}@${best}` : `${user}@${dom}`;
  }
  const phoneE164 = raw => {
    let d = raw.replace(/\D/g, '');
    if (d.startsWith('00972')) d = d.slice(2);
    if (d.startsWith('972')) d = '0' + d.slice(3);
    return /^05\d{8}$/.test(d) ? '+972' + d.slice(1) : null;
  };
  const note = (input, html, err) => {
    const box = input.closest('.field') || input;
    let m = box.nextElementSibling && box.nextElementSibling.matches('.field-msg') ? box.nextElementSibling : null;
    box.classList.toggle('is-bad', !!err);
    if (!html) { m && m.remove(); return null; }
    if (!m) { m = document.createElement('p'); box.after(m); }
    m.className = 'field-msg' + (err ? ' field-msg--err' : ''); m.setAttribute('role', err ? 'alert' : 'status'); m.innerHTML = html;
    return m;
  };
  function checkEmail(input) {
    const typed = input.value; if (!typed || input.dataset.keep === typed) return;
    const fixed = fixEmail(typed);
    if (fixed === typed) { note(input, ''); return; }
    input.value = fixed;
    const m = note(input, `תיקנו ל־<b dir="ltr">${fixed.replace(/</g, '')}</b> <button type="button">לא, השאירו כמו שכתבתי</button>`);
    $('button', m).addEventListener('click', () => { input.value = typed; input.dataset.keep = typed; note(input, ''); input.focus(); });
  }
  function signupForms() {
    $$('form input[type="email"]:not([data-fix])').forEach(input => {
      input.dataset.fix = '1';
      input.addEventListener('change', () => checkEmail(input));
      input.form.addEventListener('submit', () => checkEmail(input), true);
    });
    $$('input[data-phone]:not([data-ready])').forEach(input => {
      input.dataset.ready = '1';
      const form = input.form, tags = $('[data-tags]', form);
      const base = tags ? tags.value : '';
      input.addEventListener('input', () => { input.setCustomValidity(''); note(input, ''); });
      form.addEventListener('submit', e => {
        const tel = phoneE164(input.value);
        if (!tel) {
          e.preventDefault(); e.stopImmediatePropagation();
          note(input, 'צריך מספר נייד ישראלי, למשל 050-1234567', true); input.focus();
          return;
        }
        // customer forms drop contact[phone], so the number travels as a tag
        if (tags) tags.value = `${base}, tel-${tel.slice(1)}`;
      });
    });
  }
  document.addEventListener('shopify:section:select', e => { if (e.target.querySelector('[data-cpop]')) open($('#ClubPopup')); });
  document.addEventListener('shopify:section:deselect', e => { if (e.target.querySelector('[data-cpop]')) close(); });

  /* ---------- film strip / look ---------- */
  function film() {
    $$('[data-film]').forEach(w => {
      const tr = $('.film__track', w);
      if (!tr || tr.dataset.loop) return;
      tr.dataset.loop = '1';
      const frames = $$('.film__frame', tr);
      if (frames.length < 2) return;
      frames.forEach(f => {
        const c = f.cloneNode(true);
        c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block');
        $$('a', c).forEach(a => a.tabIndex = -1);
        tr.appendChild(c);
      });
      w.classList.add('film--loop');
      const first = $('.film__frame[aria-hidden]', tr);
      const period = () => first.offsetLeft - frames[0].offsetLeft;
      let pos = 0, last = 0, hold = false, onScreen = false, resume;
      const wrap = x => { const p = period(); return p > 0 ? ((x % p) + p) % p : x; };
      const sync = () => { pos = wrap(tr.scrollLeft); if (Math.abs(pos - tr.scrollLeft) > 1) tr.scrollLeft = pos; };
      const pause = () => { hold = true; clearTimeout(resume); };
      const later = (ms = 1600) => { clearTimeout(resume); resume = setTimeout(() => { sync(); hold = false; }, ms); };
      const speed = () => innerWidth < 900 ? 30 : 42; // px per second: slow enough to look at each photo
      const step = ts => {
        if (!tr.isConnected) return;
        const dt = last ? Math.min(64, ts - last) : 0; last = ts;
        if (!hold && onScreen && !document.hidden && !w.classList.contains('is-paused')) {
          pos = wrap(pos + speed() * dt / 1000); tr.scrollLeft = pos;
        }
        requestAnimationFrame(step);
      };
      'IntersectionObserver' in window ? new IntersectionObserver(([en]) => onScreen = en.isIntersecting).observe(tr) : onScreen = true;
      tr.addEventListener('pointerdown', pause); tr.addEventListener('touchstart', pause, { passive: true });
      ['pointerup', 'pointercancel', 'touchend'].forEach(ev => tr.addEventListener(ev, () => later(), { passive: true }));
      tr.addEventListener('wheel', () => { pause(); later(); }, { passive: true });
      tr.addEventListener('scroll', () => { if (hold) { const x = wrap(tr.scrollLeft); if (Math.abs(x - tr.scrollLeft) > 1) tr.scrollLeft = x; } }, { passive: true });
      w.addEventListener('mouseenter', pause); w.addEventListener('mouseleave', () => later(400));
      w.addEventListener('focusin', pause); w.addEventListener('focusout', () => later());
      $$('[data-dir]', w).forEach(b => b.addEventListener('click', () => { pause(); tr.scrollBy({ left: -b.dataset.dir * tr.clientWidth * .6, behavior: 'smooth' }); later(1200); }));
      requestAnimationFrame(step);
    });
    $$('[data-look]').forEach(look => {
      const hots = $$('.hot', look), items = $$('.look__item', look);
      const set = i => { hots.forEach((h, j) => h.classList.toggle('is-on', i === j)); items.forEach((it, j) => it.classList.toggle('is-on', i === j)); };
      hots.forEach((h, i) => { h.addEventListener('mouseenter', () => set(i)); h.addEventListener('click', () => { set(i); items[i] && items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }); });
      items.forEach((it, i) => it.addEventListener('mouseenter', () => set(i)));
    });
  }

  /* ---------- product page ---------- */
  function pdp() {
    const root = $('[data-pdp]'); if (!root) return;
    const section = root.closest('.shopify-section') || document;
    const p = readJSON(section); if (!p) return;
    const form = $('[data-product-form]', root), select = $('[data-variant-select]', root);
    const atc = $('[data-atc]', root), msg = $('[data-size-msg]', root), priceBox = $('[data-price] strong', root);
    const sticky = $('[data-sticky-atc]'), sBtn = sticky && $('[data-sticky-btn]', sticky), sPrice = sticky && $('[data-sticky-price]', sticky);
    const groups = $$('[data-option]', root);
    const fitNote = msg ? msg.textContent : '';
    const initial = p.variants.find(v => String(v.id) === new URLSearchParams(location.search).get('variant'));
    const picked = p.options.map((_, i) => initial ? initial.options[i] : null);
    if (p.options.length === 1 && p.variants.length === 1) picked[0] = p.variants[0].options[0];

    const resolve = () => picked.every(Boolean) ? p.variants.find(v => v.options.every((o, i) => o === picked[i])) : null;
    function paint() {
      groups.forEach(g => {
        const idx = +g.dataset.option;
        $$('.size', g).forEach(b => {
          const val = b.dataset.value;
          const match = p.variants.filter(v => v.options[idx] === val && v.options.every((o, i) => i === idx || !picked[i] || o === picked[i]));
          const qty = match.reduce((a, v) => a + (v.available ? v.qty : 0), 0);
          b.classList.toggle('is-on', picked[idx] === val);
          b.setAttribute('aria-pressed', picked[idx] === val ? 'true' : 'false');
          b.classList.toggle('is-out', qty <= 0);
          b.classList.toggle('is-low', qty > 0 && qty <= S.lowStock);
          b.disabled = qty <= 0;
        });
        const lbl = $(`[data-picked="${idx}"]`, root); if (lbl) lbl.textContent = picked[idx] || '—';
      });
      const v = resolve();
      if (v) {
        select.value = v.id;
        priceBox && (priceBox.innerHTML = `<span class="ltr">${money(v.price)}</span>`);
        sPrice && (sPrice.innerHTML = `<span class="ltr">${money(v.price)}</span>`);
        atc.disabled = !v.available;
        atc.textContent = v.available ? `${S.i18n.add} · ${money(v.price)}` : S.i18n.soldOut;
        sBtn && (sBtn.textContent = v.available ? S.i18n.add : S.i18n.soldOut, sBtn.disabled = !v.available);
        if (msg && groups.length) { msg.textContent = v.available ? stockMsg(v.qty) : S.i18n.soldOut; msg.className = 'size-msg' + (v.qty <= S.lowStock ? ' is-low' : ''); }
        if (initial || picked.some(Boolean)) history.replaceState(null, '', `${location.pathname}?variant=${v.id}`);
      }
    }
    groups.forEach(g => g.addEventListener('click', e => {
      const b = e.target.closest('.size'); if (!b || b.disabled) return;
      picked[+g.dataset.option] = b.dataset.value; paint();
    }));
    function submit(e) {
      e && e.preventDefault();
      const v = resolve();
      if (!v) {
        const g = groups[picked.findIndex(x => !x)] || groups[0];
        g && g.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 320 });
        if (msg) { msg.textContent = S.i18n.whichSize; msg.className = 'size-msg is-low'; }
        g && g.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      add(v.id, 1, atc);
    }
    form && form.addEventListener('submit', submit);
    sBtn && sBtn.addEventListener('click', submit);
    if (msg && !picked.some(Boolean)) msg.textContent = fitNote;
    paint();

    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const past = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', past);
        document.body.classList.toggle('has-sticky', past);
      }).observe(atc);
    }
    const track = $('.gallery__track', root), count = $('[data-g-count]', root), dots = $$('.gallery__dots i', root);
    const total = $$('.gallery__slide', root).length;
    track && count && track.addEventListener('scroll', () => {
      const i = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
      count.textContent = `${String(i + 1).padStart(2, '0')} / ${String(total).padStart(2, '0')}`;
      dots.forEach((d, j) => d.classList.toggle('is-on', j === i));
    }, { passive: true });
  }

  /* ---------- recommendations ---------- */
  function recs() {
    $$('[data-recs-wrap]').forEach(async wrap => {
      try {
        const html = await (await fetch(wrap.dataset.url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recs]');
        if (fresh && fresh.children.length) { const cur = $('[data-recs]', wrap); cur.innerHTML = fresh.innerHTML; init(cur); }
      } catch (_) {}
    });
  }

  /* ---------- collection sort ---------- */
  function sort() {
    const s = $('[data-sort]'); if (!s) return;
    s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u; });
  }

  const boot = () => { init(); announce(); motion(); videos(); headerOver(); film(); pdp(); recs(); sort(); clubPopup(); signupForms(); drop(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();

  // theme editor: re-init sections when they reload
  document.addEventListener('shopify:section:load', e => { init(e.target); motion(); videos(); film(); signupForms(); headerOver(); if (e.target.querySelector('[data-pdp]')) pdp(); });
})();
